import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const short = (v) => (v >= 1e9 ? `${(v / 1e9).toFixed(1)}B` : v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e3 ? `${(v / 1e3).toFixed(0)}K` : `${Math.round(v)}`);

export function TailCategoryChart({ rows, cs }) {
  const data = (rows || []).slice(0, 10);
  return (
    <Card data-testid="tail-category-chart">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Tail Spend by Category</CardTitle>
        <p className="text-xs text-muted-foreground">Categories with the most tail spend and tail suppliers are the easiest consolidation wins.</p>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={Math.max(200, data.length * 34)}>
          <BarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" tickFormatter={(v) => `${cs}${short(v)}`} fontSize={11} />
            <YAxis type="category" dataKey="category" width={170} fontSize={11} />
            <Tooltip formatter={(v, _n, p) => [`${cs}${Math.round(v).toLocaleString()} · ${p.payload.suppliers} suppliers`, 'Tail spend']} />
            <Bar dataKey="spend" fill="#f59e0b" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
